import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { Button } from 'bootstrap-4-react/lib/components';

export const NOTE_MAX_LENGTH = 4000;

// Popup opened from the Actions column to add a new note to a user request.
const AddNoteModal = ({ show, item, loading, onCancel, onSave }) => {
    const [note, setNote] = useState('');

    useEffect(() => {
        if (show) setNote('');
    }, [show, item]);

    const trimmedNote = note.trim();
    const canSave = trimmedNote.length > 0 && !loading;

    const handleSave = () => {
        if (!canSave) return;
        onSave(trimmedNote);
    };

    return (
        <Dialog
            open={!!show}
            onClose={loading ? undefined : onCancel}
            aria-labelledby="add-note-title"
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle id="add-note-title">
                <i className="fa fa-sticky-note-o mr-2" aria-hidden="true"></i>Notes
            </DialogTitle>
            <DialogContent dividers>
                {item && (
                    <div className="mb-3">
                        <div>
                            <strong>{item.FullName}</strong>
                            {item.Email ? <span className="text-muted"> · {item.Email}</span> : null}
                        </div>
                        <div className="text-muted small">
                            {item.CompanyName ? `${item.CompanyName} · ` : ''}
                            Signed up {item.CreatedDate ? moment(item.CreatedDate).format('MM-DD-YYYY | h:mm:ss A') : ''}
                        </div>
                    </div>
                )}
                <label className="labelHead" htmlFor="user-request-note">
                    Note <span style={{ color: '#dc3545' }}>*</span>
                </label>
                <textarea
                    id="user-request-note"
                    data-testid="user-request-note-textarea"
                    className="form-control"
                    rows={6}
                    maxLength={NOTE_MAX_LENGTH}
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    placeholder="Add a note about this request (call details, follow-ups, pending documents...)"
                    disabled={loading}
                />
                <div className="text-muted small mt-1">
                    Each note is saved with your name and the current date and time.
                </div>
            </DialogContent>
            <DialogActions>
                <Button className="cus-primary-transparent-btn" onClick={onCancel} disabled={loading}>
                    Cancel
                </Button>
                <Button className="cus-primary-bg-btn" onClick={handleSave} disabled={!canSave}>
                    {loading ? 'Saving...' : 'Save'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

AddNoteModal.propTypes = {
    show: PropTypes.bool,
    item: PropTypes.shape({
        Id: PropTypes.number,
        FullName: PropTypes.string,
        Email: PropTypes.string,
        CompanyName: PropTypes.string,
        CreatedDate: PropTypes.string,
    }),
    loading: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
};

AddNoteModal.defaultProps = {
    show: false,
    item: null,
    loading: false,
};

export default AddNoteModal;
